import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';
import { capitalize } from '../../utils/formattingUtils';
import { useTranslation } from 'react-i18next';
import tPaths from '../../utils/tPaths';
import useApi from '../../utils/useApi';
import { endpoints } from '../../utils/endpoints';

interface IProps {
  setDialog: Function;
  user: any;
  tableName: string;
  handleRemove: (tableName: string, itemId: string) => void;
}
const DeleteUserDialog: React.FC<IProps> = ({ handleRemove, tableName, user, setDialog }) => {
  const { t } = useTranslation();

  const userFileds = Object.keys(user)

    .filter((key) => key !== 'delete' && key !== '_id')

    .map((key) => ({ key: capitalize(key), value: user[key] }));

  const handleClose = () => setDialog((s: any) => ({ ...s, isOpen: false }));

  return (
    <Dialog
      open={true}
      onClose={() => {}}
      fullWidth={true}
      maxWidth={'xs'}
      style={{ bottom: '150px' }}
      onBackdropClick={handleClose}
    >
      <DialogTitle>{t(tPaths.table.deleteAsk)}</DialogTitle>

      <DialogContent>
        {userFileds.map((field: any) => (
          <Typography variant="subtitle1">
            <strong>{field.key}</strong> - {field.value}
          </Typography>
        ))}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          {t(tPaths.global.cancel)}
        </Button>

        <Button
          onClick={() => {
            handleRemove(tableName, user._id);
            handleClose();
          }}
          color="primary"
          autoFocus
        >
          {t(tPaths.global.delete)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUserDialog;
